import React from 'react'
import img2021 from '../components/images/amazonspn.png'

const events = () => {
    return (

        <>
            <div className='container'>
                <div className='Container'>
                    <div className="row  m-2">
                        <img src={img2021} alt='amazonspn' />
                    </div>
                    <div className="row m-2">
                        {/* <div className="col-12 col-md-6 p-2 "> */}

                            <h2>Maximize Efficiency and Growth with
                                E Seller Support, Your Amazon ATES Partner
                            </h2>
                            <p> As an accredited Amazon ATES partner, E Seller Support is uniquely positioned to offer you unparalleled expertise and support in managing your Amazon storefront. Our comprehensive range of services, from account management to product optimization, ensures that your business maximizes its potential on the world’s largest online marketplace. With our specialized knowledge and Amazon-backed solutions, we empower you to navigate the complexities of selling on Amazon seamlessly and effectively, driving your success to new heights. Trust E Seller Support to deliver the results you need to thrive in the competitive e-commerce landscape. </p>
                        {/* </div> */}
                        {/* <div className="col-12 col-md-6 p-2">
                            <div className="ratio ratio-16x9">
                                <iframe
                                    src="https://www.youtube.com/embed/4H0Jr42WOZg?si=R-56ugCmVbigwx9J"
                                    title="YouTube video player"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowFullScreen
                                ></iframe>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
        </>
    )
}

export default events